import { getAttendanceConfig } from './config/AttendanceConfig'

export default {
  attendance: (state) => state.attendance,
  attendanceId: (state) => state.attendance?.id,
  attendanceDiseaseId: (state) => state.attendance?.disease?.id,
  attendanceData: (state) => state.attendance?.data || null,
  attendanceMode: (state) => state.attendance?.mode || 'normal',
  attendanceVersion: (state) => state.attendance?.version || null,
  attendanceHypothesis: (state) => state.attendance?.hypothesis || null,
  attendancePatient: (state) => state.attendance?.patient || null,
  patientEmail: (state) => state.attendance?.patientEmail || null,
  patientMobile: (state) => state.attendance?.patientMobile ?? state.attendance?.patient.number,
  patientAcceptedTerms: (state) => state.attendance?.patient?.acceptedTerms || false,
  attendanceNote: (state) => state.attendance?.note || null,
  attendanceConfig: (_, getters) => getAttendanceConfig(getters.attendanceDiseaseId, getters.attendanceMode, getters.attendanceVersion),
  currentPhaseKey: (state, getters) =>
    getters.attendanceConfig
      ? getters.attendanceConfig.getPhase(state.currentStepIndex, state.currentPhaseIndex)?.key
      : null,
  getPhaseDataByKey: (_, getters) => (phaseKey) => getters.attendanceData ? getters.attendanceData[phaseKey] : null,
  isFirstStep: (state) => state.currentStepIndex === 0,
  isLastStep: (state, getters) => state.currentStepIndex === getters.attendanceConfig.getLastStepIndex(),
  isFirstPhaseInStep: (state) => state.currentPhaseIndex === 0,
  isLastPhaseInStep: (state, getters) =>
    state.currentPhaseIndex === getters.attendanceConfig.getLastPhaseIndex(state.currentStepIndex),
  isFinalPhase: (_, getters) => getters.isLastStep && getters.isLastPhaseInStep,
  isStartPhase: (_, getters) => getters.isFirstStep && getters.isFirstPhaseInStep,
  steps: (_, getters) => getters.attendanceConfig.getSteps(),
  currentPhases: (state, getters) => getters.attendanceConfig.getPhases(state.currentStepIndex),
  currentOriginalPhases: (state, getters) => getters.attendanceConfig.getOriginalPhases(state.currentStepIndex),
  summaryComponent: (_, getters) => getters.attendanceConfig.getSummaryComponent(),
  hypothesisComponent: (_, getters) => getters.attendanceConfig.getHypothesisComponent(),
}
